import type { AvailabilityStatus, TrafficType } from '@psp-aggregator/sdk';
import sdk from '@psp-aggregator/sdk';
import { keepPreviousData } from '@tanstack/react-query';

export interface UseOffersParams {
  countries?: string[];
  currencies?: string[];
  enabled?: boolean;
  integrationMethods?: string[];
  isDeleted?: boolean;
  limit?: number;
  page?: number;
  providerIds?: string[];
  search?: string;
  sort?: 'newest' | 'oldest';
  statuses?: AvailabilityStatus[];
  trafficTypes?: TrafficType[];
}

export const useOffers = ({
  countries,
  currencies,
  enabled = true,
  integrationMethods,
  isDeleted,
  limit,
  page,
  providerIds,
  search,
  sort,
  statuses,
  trafficTypes,
}: UseOffersParams = {}) =>
  sdk.queries.useListAdminOffers(
    page,
    limit,
    search,
    sort,
    statuses,
    providerIds,
    countries,
    currencies,
    trafficTypes,
    integrationMethods,
    isDeleted,
    { enabled, placeholderData: keepPreviousData },
  );
